// extracted by mini-css-extract-plugin
var _1 = "L5smJ";
var _2 = "SlwBr";
var _3 = "owqub";
var _4 = "Vgz7H";
var _5 = "vrRV7";
export { _1 as "base", _2 as "candidate", _3 as "condition", _4 as "quantity", _5 as "unit" }
